<!-- src/components/AnnouncementCard.vue -->
<template>
  <div class="col">
    <div class="card shadow mb-3">
      <img :src="announcement.url" :alt="announcement.title" class="img-fluid" />
      <p class="d-flex justify-content-end text-white" style="margin: -30px 5px 0 0">
        <i class="fa-solid fa-location-dot mr-1"></i> {{ announcement.location }}
      </p>
      <div class="d-flex justify-content-around bg-primary text-light py-1">
        <span><i class="fa-solid fa-road"></i> {{ announcement.km }} Km</span>
        <span><i class="fa-solid fa-calendar-days"></i> {{ announcement.year }}</span>
      </div>
      <div class="card-body text-center m-0 p-0">
        <h4 class="m-0">{{ announcement.title }}</h4>
        <span class="text-end">R$ {{ announcement.price }}</span>
      </div>
      <div class="card-footer d-flex justify-content-between">
        <a :href="announcement.link" target="_blank" class="btn btn-primary">
          {{ $t('common.actions.view') }}
        </a>
        <label class="btn btn-sm btn-secondary"><input type="checkbox" @click="toggleCheckboxes" value="Toggle all"> Comparar</label>
      </div>
    </div>
  </div>
</template>
  
<script>
  export default {
    name: "CardAnnouncement",
    props: {
      announcement: {
        type: Object,
        required: true,
        validator: (value) =>
          value &&
          typeof value.title === "string" &&
          typeof value.description === "string" &&
          typeof value.url === "string" &&
          (typeof value.image === "string" || value.image === null)
      },
    },
  };
</script>
  
<style scoped>
</style>
